import { Injectable } from '@angular/core';
import {Subject} from "rxjs";
import {PaymentDetailInfoDto} from "../models/payment.models";

@Injectable({
  providedIn: 'root'
})
export class PaymentDetailInfoService {

  paymentDetail$: Subject<PaymentDetailInfoDto> = new Subject<PaymentDetailInfoDto>()

}
